import { createReducer } from '@reduxjs/toolkit';
import { arrayToHash } from 'helpers/helperFunctions';
import { QuestOnboarding } from 'models/QuestOnboarding';
import { getQuestsOnboardings } from './actions';
import { QuestsOnboardingsState } from './typings';

const initialState: QuestsOnboardingsState = {
  questsOnboardings: {},
};

export default createReducer<QuestsOnboardingsState>(initialState, (builder) =>
  builder.addCase(getQuestsOnboardings.fulfilled, (state, action) => ({
    questsOnboardings: arrayToHash<QuestOnboarding>(
      action.payload,
      (questOnboarding) => questOnboarding.id,
      state.questsOnboardings,
    ),
    lastUpdatedAt: new Date().toISOString(),
  })),
);
